/* eslint-disable camelcase */
export const CONSTANT = {
  KEYS: {
    USER_STATUS: {
      PENDING_APPROVAL: 'PENDING_APPROVAL',
      APPROVED: 'APPROVED'
    },
    ROLES: {
      ADMIN: 'ADMIN',
      SALES_REP: 'SALES_REP',
      ORDER_FULFILLMENT: 'ORDER_FULFILLMENT',
      PROPOSAL_HOUSE: 'PROPOSAL_HOUSE',

      SALES_MANAGER: 'SALES_MANAGER',
      SALES_SUPPORT: 'SALES_SUPPORT'
    },
    CHANNELS: {
      SBS: 'SBS',
      BSE_BSW: 'BSE BSW',
      LSS: 'LSS',
      TAM: 'TAM',
      BCX: 'BCX',
      TIP_SALES: 'TIP SALES',
      BCX_CARE: 'BCX_CARE',
      BCX_HD: 'BCX_HD',
      DEALER: 'DEALER',
      INKEROS: 'INKEROS',
      INKEROS_EAST: 'INKEROS_EAST',
      ISS: 'ISS',
      ISS_EAST: 'ISS_EAST',
      LTS: 'LTS',
      NGM: 'NGM',
      NGM_TECHS: 'NGM_TECHS',
      TQ: 'TQ',
      ISS_CMB: 'ISS CMB',
      FIELDS_SALES_WEST: 'FIELDS SALES WEST',
      ADT: 'ADT',
      HEALTH: 'Health',
      CSD: 'CSD',
      NBD: 'NBD',
      CORP_STORE: 'CORP_STORE'
    }
  },
  ROLES: {
    ADMIN: 0,
    SALES_REP: 0,
    SOV_AGENT: 0,
    SRT_GROUP: 0,
    SOV_ADMIN: 0,
    PRODUCT_TEAM: 0
  },
  CHANNELS: {
    DEALER_ADT: 0,
    CORP_STORE: 0,
    SBS: 0,
    BSE_BSW: 0,
    LSS: 0,
    TAM: 0,
    ADT_SALES: 0,
    TIP_SALES: 0,
    DEALER: 0
  },
  DASHBOARD_LABELS: {
    SALES_REP_DASHBOARD: 'My Orders',
    CC_SALES_REP_DASHBOARD: 'Sales Rep Dashboard',
    SOV_DASHBOARD: 'Order Fulfillment Dashboard',
    QUOTE_APPROVAL_DASHBOARD: 'Quote Approval Dashboard',
    BA_SALES_REP_DASHBOARD: 'My Orders',
    IOT_SALES_REP_DASHBOARD: 'My Orders',
    BA_ORDER_FULFILLMENT_DASHBOARD: 'Order Fulfillment Dashboard',
    IOT_SOV_DASHBOARD: 'Order Fulfillment Dashboard'
  }
};

export const RECAPTCHA_SITE_KEY = '6LeDZq4ZAAAAAPrApKRb5v9UFb7_nd09kiY_S8hJ';

export const ROLES = ['SALES_REP', 'SALES_REP', 'SOV_AGENT', 'SRT_GROUP'];

export const channels = [
  {
    text: 'SBS',
    value: 'SBS'
  },
  {
    text: 'Fields Sales West',
    value: 'FIELDS_SALES_WEST'
  },
  {
    text: 'BSE_BSW',
    value: 'BSE_BSW'
  },
  {
    text: 'LSS',
    value: 'LSS'
  },
  {
    text: 'TAM',
    value: 'TAM'
  },
  {
    text: 'TIP Sales',
    value: 'TIP_SALES'
  },
  {
    text: 'BCX',
    value: 'BCX'
  },
  {
    text: 'BCX Care',
    value: 'BCX_CARE'
  },
  {
    text: 'BCX HD',
    value: 'BCX_HD'
  },
  {
    text: 'Dealer',
    value: 'DEALER'
  },
  {
    text: 'Inkeros',
    value: 'INKEROS'
  },
  {
    text: 'Inkeros East',
    value: 'INKEROS_EAST'
  },
  {
    text: 'ISS',
    value: 'ISS'
  },
  {
    text: 'ISS CMB',
    value: 'ISS_CMB'
  },
  {
    text: 'ISS East',
    value: 'ISS_EAST'
  },
  {
    text: 'LTS',
    value: 'LTS'
  },
  {
    text: 'NGM',
    value: 'NGM'
  },
  {
    text: 'NGM Techs',
    value: 'NGM_TECHS'
  },
  {
    text: 'TQ',
    value: 'TQ'
  }
];

export const profileKeysToList = [
  'name',
  'email',
  'role_id',
  'channelName',
  'dealership',
  'outlet',
  'cpms_id',
  'sales_manager',
  'sales_manager_email'
];

export const businessConnectContactCentreOnlineTool =
  'Contact_Centre_Online_Tool';
export const businessConnectContactCentreLandingPage = 'Contact_Centre_Landing';
export const businessConnectQuoteToolOrderCategoryName =
  'TELUS_Business_Connect_Quote_Tool_Order_Form';
export const businessAppsCategoryName = 'TELUS_Business_Apps';
export const iotCategoryName = 'TELUS_IOT';
export const iotPrequalificationForm = 'IoT_Prequalification';
export const iotOrderForm = 'IoT_Order_Form';
export const businessAppsPrequalificationForm = 'Business_App_Prequalification';
export const businessAppsOrderForm = 'Business_App_Order_Form';
export const constactCentreCategoryName =
  'TELUS_Business_Connect_Contact_Centre_&_Professional_Services';
export const businessConnectQuoteToolForm = 'Business_Connect_Quote_Tool';
export const orderDetailsForm = 'Order_Details';
export const orderSummaryForm = 'Order_Summary';
export const prequalificationForm = 'prequalification';
export const isChannelDealer = 'Dealer';
export const fieldDealerNote = 'dealerNote';
export const orderStatus = {
  incomplete: 'INCOMPLETE',
  pendingValidation: 'PENDING_VALIDATION',
  validated: 'ORDER_VALIDATED',
  revisionRequired: 'REVISION_REQUIRED',
  waitingOnCredit: 'WAITING_ON_CREDIT',
  waitingOnSales: 'WAITING_ON_SALES',
  contractSigned: 'CONTRACT_SIGNED',
  contractSent: 'CONTRACT_SENT',
  orderCanceled: 'ORDER_CANCELED',
  withConcierge: 'WITH_CONCIERGE',
  contractExpired: 'CONTRACT_EXPIRED',
  implementationInProgress: 'IMPLEMENTATION_IN_PROGRESS',
  waitingOnCompletionCall: 'WAITING_ON_COMPLETION_CALL',
  orderInstalled: 'ORDER_INSTALLED',
  orderPlaced: 'ORDER_PLACED',
  orderActivated: 'ORDER_ACTIVATED',
  orderShipped: 'ORDER_SHIPPED',
  orderCompleted: 'ORDER_COMPLETED',
  orderSubmitted: 'ORDER_SUBMITTED'
};
export const quoteStatus = {
  incomplete: 'INCOMPLETE',
  pendingApproval: 'PENDING_APPROVAL',
  approved: 'QUOTE_APPROVED',
  waitingOnSales: 'WAITING_ON_SALES'
};

export const contentFulFields = {
  [prequalificationForm]: {
    existingInternetConnection:
      'doesTheCustomerHaveAnExistingInternetConnection',
    telusWorkplace: 'isThisOrderAPartOfTELUSWorkplace',
    fieldCustomerSegment: 'customerSegment',
    fieldMobileOrVoiceEdition: 'isThisOrderForAMobileOrVoiceEdition'
  },
  starterSeatDetails: 'starterSeatDetails',
  officeSeatDetails: 'officeSeatDetails'
};

export const starterSeatName = 'Starter Seat';
export const officeSeatName = 'Office Seat';

// Payload keys
export const keyDevices = 'devices';
export const keyWhiteGloveLocations = 'whiteGloveLocations';
export const keyDirectoryListingDetails = 'directoryListingDetails';
export const keyDirectoryListing = 'Directory Listing';
export const keyDirectoryListingType = 'directoryListing';
export const keyPrimaryDirectoryListingType = 'primaryDirectoryListingType';
export const keyTotalNoOfSeats = 'totalNoOfSeats';
export const keySpareDevices = 'additionalSpareDevices';
export const keyFeatures = 'features';
export const keyStarterSeatRateStandard = 'starterSeatRateStandard';
export const keyOfficeSeatRateStandard = 'officeSeatRateStandard';
export const keyGSuiteBusinessLicences = 'gSuiteBusinessLicences';
export const keyGSuiteEligible = 'gSuiteEligible';
export const keyGSuiteComplimentarySeats = 'gSuiteComplimentarySeats';
export const keyChannelId = 'channelId';
export const keyChannelName = 'channelName';
export const keyDevicesWereChanged = 'devicesWereChanged';
export const keyOutlet = 'outlet';
export const keyBusinessAppPlans = 'businessAppPlans';

// Form fields names
export const fieldEmailSigningAuthority = 'email_signingAuthority';
export const fieldProductNameBA = 'productNameBA';
export const fieldAddProductBA = 'addProductBA';
export const fieldStreetAddress_address = 'streetAddress_address';
export const fieldStreetNumber_address = 'streetNumber_address';
export const fieldOrderRequestTypeBA = 'orderRequestTypeBA';
export const fieldOtherServicesCustomerWillTakeBA =
  'otherServicesCustomerWillTakeBA';
export const fieldGoogleProductEditionsBA = 'googleProductEditionsBA';
export const fieldESChatProductEditionsBA = 'esChatProductEditionsBA';
export const fieldMicrosoftProductEditionsBA = 'microsoftProductEditionsBA';
export const fieldTermProductBA = 'termProductBA';
export const fieldProductInOrderFor = 'productInOrderFor';
export const fieldSameAsAdminContact = 'sameAsAdminContact';
export const fieldUploadCustomerReadinessChecklist =
  'uploadCustomerReadinessChecklist';
export const fieldEeEnterEmailSigningAuthority =
  'reEnterEmail_signingAuthority';
export const fieldProvinceOfTheOrder = 'provinceOfTheOrder';
export const fieldTypeOfInstallation = 'typeOfInstallation';
export const fieldBusinessConnectEdition = 'businessConnectEdition';
export const fieldBusinessConnectEditionWorkplace =
  'businessConnectEditionWorkplace';
export const fieldDoesCustomerRequirePrimaryIpDeskPhones =
  'doesCustomerRequirePrimaryIpDeskPhones';
export const fieldDoesCustomerRequireSpareDevices =
  'doesCustomerRequireSpareDevices';
export const fieldAddDevices = 'addDevices';
export const fieldAddSpareDevices = 'addSpareDevices';
export const fieldStarterSeat = 'starterSeat';
export const fieldOfficeSeats = 'officeSeats';
export const fieldDoYouWantToBundleThisBusinessConnectServiceWithWLS =
  'doYouWantToBundleThisBusinessConnectServiceWithWLS';
export const fieldDoesTheCustomerRequireWhiteGlove =
  'doesTheCustomerRequireWhiteGlove';
export const fieldNumberOfSitesThatRequireWhiteGlove =
  'numberOfSitesThatRequireWhiteGlove';
export const fieldNumberOfSeatsThatRequireWhiteGlove =
  'numberOfSeatsThatRequireWhiteGlove';
export const fieldHowCustomerWantToPayForWhiteGlove =
  'howCustomerWantToPayForWhiteGlove';
export const fieldTelusBusinessConnectRoomsNumberOfLicences =
  'telusBusinessConnectRooms_numberOfLicences';
export const fieldTelusBusinessConnectLiveReportsNumberOfLicences =
  'telusBusinessConnectLiveReports_numberOfLicences';
export const fieldTelusBusinessConnectRoomConnectorNumberOfLicences =
  'telusBusinessConnectRoomConnector_numberOfLicences';
export const fieldTelusBusinessConnectLargeMeetings200NumberOfLicences =
  'telusBusinessConnectLargeMeetings200_numberOfLicences';
export const fieldTelusBusinessConnectLargeMeetings300NumberOfLicences =
  'telusBusinessConnectLargeMeetings300_numberOfLicences';
export const fieldTelusBusinessConnectLargeMeetings500NumberOfLicences =
  'telusBusinessConnectLargeMeetings500_numberOfLicences';
export const fieldDoesTheCustomerRequireSmartHub =
  'doesTheCustomerRequireSmartHub';
export const fieldAdditionalTollFreeNumbersNumber =
  'additionalTollFreeNumbers_number';
export const fieldWhoIsTheExistingInternetProvider =
  'whoIsTheExistingInternetProvider';
export const fieldWhoIsTheExistingInternetProviderForOtherState =
  'whoIsTheExistingInternetProviderForOtherState';
export const fieldPromotionCode = 'promotionCode';
export const fieldPayment = 'payment';
export const fieldPlan = 'plan';
export const fieldNumberOfTollFreeMinutes = 'numberOfTollFreeMinutes';
export const fieldMPP = 'MPP';
export const fieldCustomerInformation = 'customerInfo';
export const fieldOfferConfiguration = 'offerConfiguration';
export const fieldIsOrderAvailableForPromotion =
  'isTheOrderAvailableForPromotion';
export const fieldVpbStarterSeatRate = 'vpbStarterSeatRate';
export const fieldVbpRequired = 'vbpRequired';
export const fieldEVSOfferCode = 'eVSOfferCode';
export const fieldBusinessType = 'businessType';
export const fieldLegalBusinessNameBusinessPersonal =
  'legalBusinessName_businessPersonal';
export const fieldLegalBusinessNameBusinessRegular =
  'legalBusinessName_businessRegular';
export const fieldOperatingAs = 'operatingAs';
export const fieldBusinessIncorporationNumber = 'businessIncorporationNumber';
export const fieldIncorporationDate = 'incorporationDate';
export const fieldDriversLicenseNumber = 'driversLicenseNumber';
export const fieldDriversLicenseExpiry = 'driversLicenseExpiry';
export const fieldDateOfBirth = 'dateOfBirth';
export const fieldInternetOffer = 'internetOffer';
export const fieldContractTerm = 'contractTerm';
export const contractTerm3Years = '3 years';
export const contractTerm5Years = '5 years';
export const fieldHaveYouArrangedWhiteGloveTechnician =
  'haveYouArrangedWhiteGloveTechnician';
export const fieldWillYourDealershipBePerformingThisWhiteGlove =
  'willYourDealershipBePerformingThisWhiteGlove';
export const fieldDealershipName = 'dealershipName';
export const fieldDealerFirstName = 'dealerFirstName';
export const fieldDealerLastName = 'dealerLastName';
export const fieldDealerPhoneNumber = 'dealerPhoneNumber';
export const fieldDealerEmail = 'dealerEmail';
export const fieldWillTheLocalPhoneNumberBePortedIn =
  'willTheLocalPhoneNumberBePortedIn';
export const fieldWillTheTollFreeBeBortedIn = 'willTheTollFreeBeBortedIn';
export const fieldProvider = 'provider';
export const fieldPin = 'pin';
export const fieldPinBA = 'pinBA';
export const fieldMsaEContractBA = 'msaEContractBA';
export const fieldBusinessIncorporationNumberBA =
  'businessIncorporationNumberBA';
export const fieldBusinessIncorporativeDateBA = 'businessIncorporativeDateBA';
export const fieldNoteStarterSeat = 'noteStarterSeat';
export const fieldNoteOfficeSeat = 'noteOfficeSeat';
export const fieldOptOutFromGSuiteBusinessLicenses =
  'optOutFromGSuiteBusinessLicenses';
export const fieldAdditionalGSuiteBusinessLicences =
  'additionalGSuiteBusinessLicences';
export const fieldGSuiteBasicLicences = 'gSuiteBasicLicences';
export const fieldGSuiteInstallAndSetup = 'gSuiteInstallAndSetup';
export const fieldGSuiteEmailMigrationServices = 'gSuiteEmailMigrationServices';
export const fieldGSuiteEmailMigrationServicesPaymentType =
  'gSuiteEmailMigrationServicesPaymentType';
export const fieldDoesTheCustomerHaveADomainAlready =
  'doesTheCustomerHaveADomainAlready';
export const fieldDomainToBeAssociatedWithGSuiteAccount =
  'domainToBeAssociatedWithGSuiteAccount';
export const fieldIsThisAnExistingGSuiteCustomer =
  'isThisAnExistingGSuiteCustomer';
export const fieldAdditionalTollFreeMinutePacks =
  'additionalTollFreeMinutePacks';
export const fieldAdditionalTollFreeNumbers = 'additionalTollFreeNumbers';
export const fieldExistingBusinessConnectBANNumber =
  'existingBusinessConnectBANNumber';
export const fieldBAN = 'BAN';
export const fieldVbpTerm = 'vbpTerm';
export const fieldContractStartDate = 'contractStartDate';

export const fieldIsThisOrderForAMobileOrVoiceEdition =
  'isThisOrderForAMobileOrVoiceEdition';
export const fieldOtherTelusServices = 'otherTelusServices';
export const fieldeContractNumber = 'eContractNumber';
export const fieldCustomerSegment = 'customerSegment';
export const fieldIsThisOrderAPartOfTELUSWorkplace =
  'isThisOrderAPartOfTELUSWorkplace';
export const fieldAvailableDiscountsAndPromotions =
  'availableDiscountsAndPromotions';
export const fieldMultisiteOrder = 'multisiteOrder';
export const fieldMsftDirectRouting = 'msftDirectRouting';
export const fieldDirectoryListing = 'directoryListing';
export const fieldDoesTheCustomerHaveAnExistingInternetConnection =
  'doesTheCustomerHaveAnExistingInternetConnection';
export const fieldVpbOfficeSeatRate = 'vpbOfficeSeatRate';
export const fieldPhoneNumberAdministratorContact =
  'phoneNumber_administratorContact';
export const fieldNumberOfMultiSites = 'numberOfMultiSites';
export const fieldStreetNumberServiceAddress = 'streetNumber_serviceAddress';
export const fieldStreetNameServiceAddress = 'streetName_serviceAddress';
export const fieldStreetNameShippingAddress = 'streetName_shippingAddress';
export const fieldUnitNumberServiceAddress = 'unitNumber_serviceAddress';
export const fieldUnitTypeServiceAddress = 'unitType_serviceAddress';
export const fieldCityServiceAddress = 'city_serviceAddress';
export const fieldProvinceServiceAddress = 'province_serviceAddress';
export const fieldPostalCodeServiceAddress = 'postalCode_serviceAddress';
export const fieldCcContractTerm = 'ccContractTerm';
export const fieldRsi = 'rsi';
export const fieldRsiLicenses = 'rsiLicenses';
export const fieldAdditionalRsiOptions = 'additionalRsiOptions';
export const fieldGenesisLicenses = 'genesisLicenses';
export const keyAdditionalRsiOptions = 'Additional RSI options';
export const fieldYesToAllAdvisories = 'yesToAllAdvisories';
export const fieldRouterPaymentOption = 'routerPaymentOption';
export const fieldCoperToFibreMigration = 'coperToFibreMigration';
export const field5UnlimitedLongDistanceCanUs = '5UnlimitedLongDistanceCanUs';
export const field10UnlimitedLongDistanceCanUs = '10UnlimitedLongDistanceCanUs';
export const fieldc2fMigrationSeatPrices = 'c2fMigrationSeatPrices';
export const fieldBusinessConnectImplementationTollFreeNumber =
  'businessConnectImplementationTollFreeNumber';
export const fieldAccountNumberBANBA = 'accountNumberBAN_BA';
export const fieldCustomerInvoiceForBA = 'customerInvoiceForBA';
export const fieldAttachmentsBA = 'attachmentsBA';
export const fieldExistingCustomerBA = 'existingCustomerBA';
export const fieldExistingCustomerDomain = 'existingCustomerDomain';
export const fieldExistingBusinessConnectOrWirelessAccountBA =
  'existingBusinessConnectOrWirelessAccountBA';
// Form field groups
export const groupVbpOptions = 'groupVbpOptions';
export const groupDirectoryListing = 'groupDirectoryListing';
export const groupBusinessConnectImplementation =
  'groupBusinessConnectImplementation';
export const fieldC2fAutomatedActivation = 'c2fAutomatedActivation';
export const fieldOfficeSeatFirstName = 'officeSeatFirstName';
export const fieldOfficeSeatLastName = 'officeSeatLastName';
export const fieldOfficeSeatEmail = 'officeSeatEmail';
export const fieldSubmittingOnBehalfOf = 'submittingOnBehalfOf';
export const fieldIsSrtTeamMember = 'isSrtTeamMember';
export const fieldPreferredInstallationDate = 'preferredInstallationDate';
export const fieldIotAccountType = 'iotAccountType';
export const fieldIotNewOrExisting = 'iotNewOrExisting';
export const fieldIotAccessAccountViaSmartDesktop =
  'iotAccessAccountViaSmartDesktop';
export const fieldIotTelusAccountNumber = 'iotTelusAccountNumber';
export const fieldIotCaratCaseId = 'iotCaratCaseId';
export const fieldIotCreditCheckPassInCarat = 'iotCreditCheckPassInCarat';
export const fieldIotAddonSpecificSubscriber = 'iotAddonSpecificSubscriber';
export const fieldIotAddonSubscriberList = 'iotAddonSubscriberList';
export const fieldIotVehicleOptions = 'iotVehicleOptions';
export const fieldIotAdditionalAttachements = 'iotAdditionalAttachements';
export const fieldIotAdditionalComment = 'iotAdditionalComment';
export const fieldIotActivationOrRenwal = 'iotActivationOrRenwal';
export const fieldIotProductSelected = 'iotProductSelected';
export const fieldCaratCreditCheckFailMessage = 'caratCreditCheckFailMessage';
export const fieldIotIncorporationNumber = 'iotIncorporationNumber';
export const fieldIotIncorporationDate = 'iotIncorporationDate';
export const fieldIotSubscribersRenewalOptions = 'iotSubscribersRenewalOptions';
export const fieldIotCreditCheckPassInMss = 'iotCreditCheckPassInMss';
export const fieldIotManagersEmailApproval = 'iotManagersEmailApproval';
export const iotGeotabFleetTrackerOEM = 'Geotab Fleet Tracker OEM';

// Form fields prices
export const priceSeatsWhiteGloveEasyPayment = 6;
export const priceSeatsWhiteGloveUpfront = 140;
export const priceSitesWhiteGloveFee = 140;

// Section names
export const sectionAdditionalFeatures = 'additionalFeatures';
export const sectionSalesRepInfo = 'salesRepInfo';
export const sectionSalesRepInfoSRT = 'salesRepInfoSRT';
export const sectionGSuiteDetails = 'gSuiteDetails';
export const sectionWhiteGloveDetails = 'whiteGloveDetails';
export const sectionNetworkPrequalification = 'networkPrequalification';
export const sectionOrderDetails = 'orderDetails';

// Payment types
export const paymentTypeUpfront = '1';
export const paymentTypeEasyPayment = '2';

// Order Type
export const orderTypeNew = 'New';
export const orderTypeNewFrench = 'Nouveau';

export const vpbRateOtherEnglish = 'Other';
export const vpbRateOtherFrench = 'Autre';

export const keyModifyQuote = 'MODIFY_QUOTE';
export const keyProceedWithOrder = 'PROCEED_WITH_ORDER';
export const keyViewOrder = 'VIEW_ORDER';
export const keyDeleteOrder = 'DELETE_ORDER';
export const keySaveQuotePdf = 'SAVE_QUOTE_PDF';
export const keyContractResend = 'CONTRACT_RESEND';
export const keyOrderReturn = 'ORDER_RETURN';

export const uploadCustomerReadinessChecklist =
  'uploadCustomerReadinessChecklist';
export const uploadCustomerReadinessChecklistTypeId = 1;
export const uploadCustomerAdvisoriesTypeId = 0;

export const multisiteUniqueFields = [
  'id',
  'orderId',
  'createdAt',
  'updatedAt',
  'streetNumber_serviceAddress',
  'streetName_serviceAddress',
  'unitNumber_serviceAddress',
  'unitType_serviceAddress',
  'city_serviceAddress',
  'province_serviceAddress',
  'postalCode_serviceAddress',
  'sameAsSigningAuthority',
  'sameAsAdmin',
  'starterSeat',
  'officeSeats',
  'doesTheCustomerRequireSmartHub',
  'doesCustomerRequirePrimaryIpDeskPhones',
  'devices',
  'doesCustomerRequireSpareDevices',
  'additionalSpareDevices',
  'doesTheCustomerRequireWhiteGlove',
  'numberOfSeatsThatRequireWhiteGlove',
  'howCustomerWantToPayForWhiteGlove',
  'features',
  'telusBusinessConnectRooms',
  'telusBusinessConnectRooms_numberOfLicences',
  'telusBusinessConnectLiveReports',
  'telusBusinessConnectLiveReports_numberOfLicences',
  'telusBusinessConnectRoomConnector',
  'telusBusinessConnectRoomConnector_numberOfLicences',
  'telusBusinessConnectLargeMeetings200',
  'telusBusinessConnectLargeMeetings200_numberOfLicences',
  'telusBusinessConnectLargeMeetings300',
  'telusBusinessConnectLargeMeetings300_numberOfLicences',
  'telusBusinessConnectLargeMeetings500',
  'telusBusinessConnectLargeMeetings500_numberOfLicences',
  'additionalTollFreeMinutePacks',
  'numberOfTollFreeMinutes',
  'staticIp',
  'additionalTollFreeNumbers',
  'msftDirectRouting',
  'directoryListing',
  'optOutFromGSuiteBusinessLicenses',
  'additionalGSuiteBusinessLicences',
  'gSuiteInstallAndSetup',
  'gSuiteEmailMigrationServices',
  'gSuiteEmailMigrationServices',
  'gSuiteEmailMigrationServicesPaymentType',
  'whichDirectoryShouldTheNumberBeListedin',
  'otherDirectoryListing',
  'directoryListingDetails',
  'availableDiscountsAndPromotions',
  'managedInternetProductsSold',
  'customerNeedCanadaDataLocalization',
  'customerRequireActiveDirectoryIntegration',
  'clientRequireBulkDeviceUpdate',
  'customerPortingNumbersFromPRICentrexSystem',
  'customerImplementingMultiLevelIVR',
  'customerUsingFaxline',
  'doesCustomerHaveATADevice',
  'customerNeedOverHeadPaging',
  'willCustomerRequireInsideWiring',
  'doesCustomerHaveCat5',
  'howManyLocationHaveCat5',
  'doesTheCustomerHaveADomainAlready',
  'domainToBeAssociatedWithGSuiteAccount',
  'firstName_administratorContact',
  'lastName_administratorContact',
  'phoneNumber_administratorContact',
  'email_administratorContact',
  'firstName_onsiteContact',
  'lastName_onsiteContact',
  'phoneNumber_onsiteContact',
  'email_onsiteContact'
];
export const smbIndirectSalesChannels = {
  'SMB Indirect Sales - Other': ['1100052561'],
  'SMB Indirect Sales - TAG': ['1100052562'],
  'SMB Indirect Sales - Elite Promotions': ['1100052563'],
  'SMB Indirect Sales- CORPO SOLUTION': ['1100052725'],
  'SMB Indirect Sales- CBTELECOM': ['1100052726'],
  'SMB Indirect Sales- IDS': ['1100052727'],
  'SMB Indirect Sales- MSG CONSULTING': ['1100052728'],
  'SMB Indirect Sales- CONNEXION FK': ['1100052729'],
  'SMB Indirect Sales- REVOLVE': ['1100052730'],
  'SMB Indirect Sales- GET INSTINCTIVE': ['1100052731'],
  'SMB Indirect Sales- TOPS TECH': ['1100052732'],
  'SMB Indirect Sales- OUTPUT': ['1100052733'],
  'SMB Indirect Sales- ATMOS MANAGEMENT': ['1100052734'],
  'SMB Indirect Sales- KOLLABB': ['1100052735'],
  'SMB Indirect Sales- UP SYSTEMS': ['1100052736'],
  'SMB Indirect Sales- WATCHDOG': ['1100052737']
};

export const channelOutletMapping = {
  'SMB Retention 1 to 30 1A': ['1100052600'],
  'SMB Retention 1 to 30 1B': ['1100052601'],
  'SMB Retention 1 to 30 1C': ['1100052602'],
  'SMB Retention 1 to 30 1D': ['1100052603'],
  'SMB Retention 30 to 100 2A': ['1100052604'],
  'SMB Retention 30 to 100 2B': ['1100052605'],
  'SMB Retention 30 to 100 2C': ['1100052606'],
  'SMB Retention 30 to 100 2D': ['1100052607'],
  'SMB Growth Sales W 1A': ['1100052608'],
  'SMB Growth Sales W 1B': ['1100052609'],
  'SMB Growth Sales W 1C': ['1100052610'],
  'SMB Growth Sales W 1D': ['1100052611'],
  'SMB Growth Sales W 2A': ['1100052612'],
  'SMB Growth Sales W 2B': ['1100052613'],
  'SMB Growth Sales W 2C': ['1100052614'],
  'SMB Growth Sales W 2D': ['1100052615'],
  'SMB Growth Sales E 1A': ['1100052616'],
  'SMB Growth Sales E 1B': ['1100052617'],
  'SMB Growth Sales E 1C': ['1100052618'],
  'SMB Growth Sales E 1D': ['1100052619'],
  'SMB Growth Sales E 1E': ['1100052620'],
  'SMB Growth Sales E 2A': ['1100052621'],
  'SMB Growth Sales E 2B': ['1100052622'],
  'SMB Growth Sales E 2C': ['1100052623'],
  'SMB Growth Sales E 2D': ['1100052624'],
  'SMB Growth Sales E 2E': ['1100052625'],
  'SMB Growth Sales E 3A': ['1100052626'],
  'SMB Growth Sales E 3B': ['1100052627'],
  'SMB Growth Sales E 3C': ['1100052628'],
  'SMB Growth Sales E 3D': ['1100052629'],
  'SMB Growth Sales E 4A': ['1100052630'],
  'SMB Growth Sales E 4B': ['1100052631'],
  'SMB Growth Sales E 4C': ['1100052632'],
  'SMB Growth Sales E 4D': ['1100052633'],
  'SMB Growth Sales E 4E': ['1100052634'],
  'SMB Growth Sales 30 to 100 1A': ['1100052635'],
  'SMB Growth Sales 30 to 100 1B': ['1100052636'],
  'SMB Growth Sales 30 to 100 1C': ['1100052637'],
  'SMB Growth Sales 30 to 100 1D': ['1100052638'],
  'SMB Growth Sales 30 to 100 2A': ['1100052639'],
  'SMB Growth Sales 30 to 100 2B': ['1100052640'],
  'SMB Growth Sales 30 to 100 2C': ['1100052641'],
  'SMB L&R 1': ['1100052642'],
  'SMB L&R 2': ['1100052643'],
  'SMB L&R 3': ['1100052644'],
  'SMB L&R 4': ['1100052645'],
  'SMB L&R 5': ['1100052646'],
  'SMB L&R TI': ['1100052647'],
  'SMB Indirect Sales - Other': ['1100052561'],
  'SMB Indirect Sales - TAG': ['1100052562'],
  'SMB Indirect Sales - Elite Promotions': ['1100052563'],
  'SMB New Growth Market 1': ['1100050829'],
  'SMB New Growth Market 2': ['1100052073'],
  'SMB Indirect Sales- CORPO SOLUTION': ['1100052725'],
  'SMB Indirect Sales- CBTELECOM': ['1100052726'],
  'SMB Indirect Sales- IDS': ['1100052727'],
  'SMB Indirect Sales- MSG CONSULTING': ['1100052728'],
  'SMB Indirect Sales- CONNEXION FK': ['1100052729'],
  'SMB Indirect Sales- REVOLVE': ['1100052730'],
  'SMB Indirect Sales- GET INSTINCTIVE': ['1100052731'],
  'SMB Indirect Sales- TOPS TECH': ['1100052732'],
  'SMB Indirect Sales- OUTPUT': ['1100052733'],
  'SMB Indirect Sales- ATMOS MANAGEMENT': ['1100052734'],
  'SMB Indirect Sales- KOLLABB': ['1100052735'],
  'SMB Indirect Sales- UP SYSTEMS': ['1100052736'],
  'SMB Indirect Sales- WATCHDOG': ['1100052737'],
  'SMB Growth Sales Advance 1': ['1100052968'],
  'SMB Growth Sales Advance 2': ['1100052976']
};

export const sof1HomeUrl = 'https://www.mysofportal.com';
export const sof2HomeUrl = 'https://www.mysalesorders.com';
export const adtHomeUrl = 'https://www.myorderdashboard.com';
